import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import ListingStatus from '../Components/listing-status/listing-status';
import { getUserTimeZoneDateFormat } from '../helpers/dateHelper';
import FileType from '../Components/file-type/file-type';
import {
  AcceptBorderedIcon,
  ApproveQuoteIcon,
  CurrencyWalletIcon,
  GredientInfoIcon,
  RejectBorderedIcon,
} from '../Components/icons/icons';
import EditBox from '../Components/edit-box/edit-box';
import CountIcon from '../Components/count-card/count-icon';
import SearchSelect from '../Components/search-select/search-select';
import Tooltip from '../Components/tooltip/tooltip';
import { checkPermission } from '../helpers/permissionHelper';
import { giveProfile } from '../Components/global-notification/notification-list';
import CommentSectionTable from '../Components/comment-section/comment-section-table';
import { CommentOutlineIcon } from '../Components/icons/comments-icon';
import IconButton from '../Components/icon-button/icon-button';
import useDialog from '../Components/dialog/useDialog';
import Dialog from '../Components/dialog/dialog';
import RequestQuotationApproval from '../Components/quotation-approval/request-approval';
import ApproveQuotation from '../Components/quotation-approval/approve-quotation';
import NotesQuotationList from '../Components/quotation-approval/notes-quotation';
import NumberCard from '../Components/number-card/number-card';
import { isNumber } from '../helpers/utils';
import Action from '../Components/action/action';

// const spotRateInfoTable = () => {
//   const [t] = useTranslation('managebooking');
//   return [
//     {
//       Header: t(
//         'managebookingscreen.bookingdetails.linerquotes.lineHaulCharge'
//       ),
//       align: 'center',
//       accessor: (row) => {
//         return (
//           <span className="pl-3">
//             {isNumber(row?.lineHaulCharge)
//               ? `${row?.lineHaulCharge} ${row?.currency || ''}`
//               : '--'}
//           </span>
//         );
//       },
//     },
//     {
//       Header: t('managebookingscreen.bookingdetails.linerquotes.fuelSurcharge'),
//       align: 'center',
//       accessor: (row) => {
//         return (
//           <span className="pl-3">
//             {isNumber(row?.fuelSurcharge)
//               ? `${row?.fuelSurcharge} ${row?.currency || ''}`
//               : '--'}
//           </span>
//         );
//       },
//     },
//     {
//       Header: t('managebookingscreen.bookingdetails.linerquotes.costPerMile'),

//       align: 'center',
//       accessor: (row) => {
//         return (
//           <span className="pl-3">
//             {isNumber(row?.costPerMile)
//               ? `${row?.costPerMile} ${row?.currency || ''}`
//               : '--'}
//           </span>
//         );
//       },
//     },
//     {
//       Header: t('managebookingscreen.bookingdetails.linerquotes.miles'),

//       align: 'center',
//       accessor: (row) => {
//         return row?.miles || '--';
//       },
//     },
//   ];
// };

const spotRateInfoTable = () => {
  const [t] = useTranslation('managebooking');
  return [
    {
      Header: t('managebookingscreen.bookingdetails.linerquotes.rateCode'),
      align: 'center',
      accessor: (row) => {
        return row?.rateCode || '--';
      },
    },
    {
      Header: t('managebookingscreen.bookingdetails.linerquotes.rateCodeValue'),
      align: 'center',
      accessor: (row) => {
        return row?.rateCodeValue || '--';
      },
    },
    {
      Header: t('managebookingscreen.bookingdetails.linerquotes.quantity'),
      align: 'center',
      accessor: (row) => {
        return isNumber(row?.quantity) ? row?.quantity : '--';
      },
    },
    {
      Header: t('managebookingscreen.bookingdetails.linerquotes.totalRate'),
      align: 'center',
      accessor: (row) => {
        return (
          <span className="pl-3">
            {isNumber(row?.totalRate)
              ? `${row?.totalRate} ${row?.currencyCode || ''}`
              : '--'}
          </span>
        );
      },
    },
    {
      Header: t('managebookingscreen.bookingdetails.linerquotes.unitRate'),
      align: 'center',
      accessor: (row) => {
        return (
          <span className="pl-3">
            {isNumber(row?.unitRate)
              ? `${row?.unitRate} ${row?.currencyCode || ''}`
              : '--'}
          </span>
        );
      },
    },
  ];
};
const linerBooking = ({
  action,
  handleClick,
  bookingId,
  refetchBookingDetails,
}) => {
  const [t] = useTranslation('managebooking');
  const { relation } = useParams();
  const columns = [
    {
      Header: t('managebookingscreen.bookingdetails.linerquotes.liner'),
      accessor: 'linearName',
    },
    {
      Header: t('managebookingscreen.bookingdetails.linerquotes.pricequoted'),
      accessor: 'totalPrice',
      align: 'center',
      Cell: (data) => {
        const { row } = data;
        return (
          <div className="d-inline-flex align-center">
            {false && (
              <CountIcon
                icon={<CurrencyWalletIcon />}
                disableBorder
                align="center"
                className="mr-5"
              />
            )}
            {row?.original?.totalPrice} {row?.original?.currency}
            {row?.original?.integrationRates?.length ? (
              <CountIcon
                label={<GredientInfoIcon />}
                disableBorder
                disableHover
                columns={spotRateInfoTable()}
                data={row?.original?.integrationRates}
                align="center"
                popoverPlacement="left"
                enableDynamicTable={true}
              />
            ) : null}
          </div>
        );
      },
    },
    {
      Header: t('managebookingscreen.bookingdetails.linerquotes.quotevalidity'),
      accessor: 'linerExpiry',
      align: 'center',
      Cell: (data) => {
        const { row } = data;
        return <p>{getUserTimeZoneDateFormat(row?.original?.linerExpiry)}</p>;
      },
    },
    {
      Header: t('managebookingscreen.bookingdetails.linerquotes.document'),
      accessor: 'quotationExpiryDate',
      align: 'center',
      Cell: (data) => {
        const { row } = data;
        return (
          <a href={row?.original?.attachments?.[0]?.url}>
            <FileType
              extantion={row?.original?.attachments?.[0]?.originalName
                ?.split('.')
                ?.pop()}
            />
          </a>
        );
      },
      // enableSortBy: true,
    },

    ...(relation === 'forwarder'
      ? [
          {
            Header: t('managebookingscreen.bookingdetails.linerquotes.status'),
            accessor: 'status',
            Cell: (data) => {
              const {
                cell: { row },
              } = data;
              return <ListingStatus statusLabel={row?.original.status} />;
            },
          },
        ]
      : []),
    ...(relation !== 'forwarder' &&
    ((!action?.sendQuote &&
      (checkPermission(giveProfile(relation), 'Booking', 'QuotationAccept') ||
        checkPermission(
          giveProfile(relation),
          'Booking',
          'QuotationReject'
        ))) ||
      (action?.approverAction &&
        (checkPermission(
          giveProfile(relation),
          'Booking',
          'Quotation Exception Approvals'
        ) ||
          checkPermission(
            giveProfile(relation),
            'Booking',
            'Indirect Material Approvals'
          ))))
      ? [
          {
            Header: t('managebookingscreen.bookingdetails.linerquotes.status'),
            accessor: 'current',
            align: 'center',
            Cell: (data) => {
              const [apiCalling, setApiCalling] = useState(false);
              const { row } = data;
              const {
                isShowing: requestApproval,
                toggle: handleRequestApproval,
              } = useDialog();
              const {
                isShowing: quotationApproval,
                toggle: handleQuotationApproval,
              } = useDialog();

              const displayAcceptRejectBtn =
                row?.original?.linerAction?.acceptReject &&
                row?.original.status === 'Pending' &&
                !row?.original?.linerAction?.approvalPending &&
                !row?.original?.linerAction?.approvalAccess;

              const displayApproverIcon =
                row?.original.status === 'Hold' &&
                row?.original?.linerAction?.approvalAccess;

              const haveActionBtnPerm =
                checkPermission(
                  giveProfile(relation),
                  'Booking',
                  'QuotationAccept'
                ) ||
                checkPermission(
                  giveProfile(relation),
                  'Booking',
                  'QuotationReject'
                );

              return (
                <div className="small-action justify-center">
                  <Dialog
                    isShowing={requestApproval}
                    hide={handleRequestApproval}
                    placement="center"
                  >
                    <RequestQuotationApproval
                      bookingId={bookingId}
                      quotationId={row?.original?._id}
                      amount={row?.original?.totalPrice}
                      currency={row?.original?.currency}
                      closeDialog={handleRequestApproval}
                      refetchBookingDetails={refetchBookingDetails}
                    />
                  </Dialog>

                  <Dialog
                    isShowing={quotationApproval}
                    hide={handleQuotationApproval}
                  >
                    <ApproveQuotation
                      approvaldata={row?.original?.approvals}
                      apiCall={(
                        status,
                        note,
                        doc,
                        toggleApprovalNotes,
                        setApiCallPending
                      ) => {
                        const closeModals = (success) => {
                          setApiCallPending(false);
                          if (success) {
                            handleQuotationApproval();
                            toggleApprovalNotes();
                          }
                        };
                        handleClick(status)(
                          row?.original,
                          note,
                          doc,
                          closeModals
                        );
                      }}
                    />
                  </Dialog>

                  {displayAcceptRejectBtn && haveActionBtnPerm && (
                    <>
                      <Tooltip
                        content={t(
                          'managebookingscreen.bookingdetails.linerquotes.tooltip.accept'
                        )}
                        direction="bottom"
                      >
                        {checkPermission(
                          giveProfile(relation),
                          'Booking',
                          'QuotationAccept'
                        ) && (
                          <IconButton
                            verient="accept"
                            onClick={() => {
                              if (row?.original?.linerAction?.exception)
                                handleRequestApproval();
                              else {
                                setApiCalling(true);
                                handleClick('Accepted')(
                                  row?.original,
                                  '',
                                  [],
                                  () => {
                                    setApiCalling(false);
                                  }
                                );
                              }
                            }}
                            disabled={apiCalling}
                          >
                            <AcceptBorderedIcon color="#666666" size="20" />
                          </IconButton>
                        )}
                      </Tooltip>

                      <Tooltip
                        content={t(
                          'managebookingscreen.bookingdetails.linerquotes.tooltip.reject'
                        )}
                        direction="bottom"
                      >
                        {checkPermission(
                          giveProfile(relation),
                          'Booking',
                          'QuotationReject'
                        ) && (
                          <CommentSectionTable
                            Icon={RejectBorderedIcon}
                            isEditor={true}
                            handleCommentSubmit={(note) => {
                              handleClick('Rejected')(row?.original, note, []);
                            }}
                            mode="reject"
                          />
                        )}
                      </Tooltip>
                    </>
                  )}

                  {displayApproverIcon && (
                    <Tooltip
                      content={t(
                        'managebookingscreen.bookingdetails.linerquotes.tooltip.approve'
                      )}
                      direction="bottom"
                    >
                      {(checkPermission(
                        giveProfile(relation),
                        'Booking',
                        'Quotation Exception Approvals'
                      ) ||
                        checkPermission(
                          giveProfile(relation),
                          'Booking',
                          'Indirect Material Approvals'
                        )) && (
                        <IconButton
                          onClick={() => {
                            handleQuotationApproval();
                          }}
                        >
                          <ApproveQuoteIcon color="#666666" size="20" />
                        </IconButton>
                      )}
                    </Tooltip>
                  )}

                  {(!displayAcceptRejectBtn || !haveActionBtnPerm) &&
                    !displayApproverIcon && (
                      <ListingStatus statusLabel={row?.original.status} />
                    )}
                </div>
              );
            },
          },
        ]
      : []),
    {
      Header: t('managebookingscreen.bookingdetails.linerquotes.notes'),
      accessor: 'notes',
      align: 'center',
      Cell: (data) => {
        const { row } = data;
        const {
          isShowing: isActivateCommentDialog,
          toggle: toggleCommentDialog,
        } = useDialog();

        return (
          /*
            <CommentSectionTable
              data={row?.original?.notes}
              Icon={CommentOutlineIcon}
              removeBG
              newCommentVersion={true}
            />
            */
          <>
            <button
              type="button"
              className="icon-button"
              id="note"
              onClick={toggleCommentDialog}
            >
              <CommentOutlineIcon />
            </button>
            <Dialog
              isShowing={isActivateCommentDialog}
              hide={toggleCommentDialog}
              placement="right"
              maskZindex={1041}
            >
              <NotesQuotationList data={row?.original?.notes} />
            </Dialog>
          </>
        );
      },
    },
  ];

  return columns;
};

const emailApprovalLiner = (t) => {
  const columns = [
    {
      Header: t('managebookingscreen.bookingdetails.linerquotes.liner'),
      accessor: 'linearName',
    },
    {
      Header: t('managebookingscreen.bookingdetails.linerquotes.pricequoted'),
      accessor: 'totalPrice',
      align: 'center',
      Cell: (data) => {
        const { row } = data;
        return (
          <div className="d-inline-flex align-center w-120-px">
            {row?.original?.totalPrice} {row?.original?.currency}
            {row?.original?.integrationRates?.length ? (
              <CountIcon
                label={<GredientInfoIcon />}
                disableBorder
                disableHover
                columns={spotRateInfoTable()}
                data={row?.original?.integrationRates}
                align="center"
                popoverPlacement="left"
                enableDynamicTable={true}
              />
            ) : null}
          </div>
        );
      },
    },
    {
      Header: t('managebookingscreen.bookingdetails.linerquotes.quotevalidity'),
      accessor: 'linerExpiry',
      align: 'center',
      Cell: (data) => {
        const { row } = data;
        return <p>{getUserTimeZoneDateFormat(row?.original?.linerExpiry)}</p>;
      },
    },
    {
      Header: t('managebookingscreen.bookingdetails.linerquotes.document'),
      accessor: 'quotationExpiryDate',
      align: 'center',
      Cell: (data) => {
        const { row } = data;
        return (
          <a href={row?.original?.attachments?.[0]?.url}>
            <FileType
              extantion={row?.original?.attachments?.[0]?.originalName
                ?.split('.')
                ?.pop()}
            />
          </a>
        );
      },
    },
    {
      Header: t('managebookingscreen.bookingdetails.linerquotes.notes'),
      accessor: 'notes',
      align: 'center',
      Cell: (data) => {
        const { row } = data;
        const {
          isShowing: isActivateCommentDialog,
          toggle: toggleCommentDialog,
        } = useDialog();

        return (
          <>
            <button
              type="button"
              className="icon-button"
              id="note"
              onClick={toggleCommentDialog}
            >
              <CommentOutlineIcon />
            </button>
            <Dialog
              isShowing={isActivateCommentDialog}
              hide={toggleCommentDialog}
              placement="right"
              maskZindex={1041}
            >
              <NotesQuotationList data={row?.original?.notes} />
            </Dialog>
          </>
        );
      },
    },
  ];

  return columns;
};

const ContractBookingSmallTable = () => {
  const [t2] = useTranslation('manageorders');
  return [
    {
      Header: t2(
        'manageordersscreen.createbookingmenu.contractedbooking.mxpart'
      ),
      align: 'center',
      accessor: 'mexPart',
    },
    {
      Header: t2(
        'manageordersscreen.createbookingmenu.contractedbooking.usapart'
      ),
      align: 'center',
      accessor: 'usaPart' || 'newUsPartyProposal',
    },
    {
      Header: t2(
        'manageordersscreen.createbookingmenu.contractedbooking.crossing'
      ),
      align: 'center',
      accessor: 'crossing',
    },
    {
      Header: t2(
        'manageordersscreen.createbookingmenu.contractedbooking.miles'
      ),
      align: 'center',
      accessor: 'miles',
    },
    {
      Header: t2('manageordersscreen.createbookingmenu.contractedbooking.fuel'),
      align: 'center',
      accessor: 'fuel',
    },
  ];
};

const ContractBookingTable = () => {
  const [t2] = useTranslation('manageorders');
  return [
    {
      Header: t2(
        'manageordersscreen.createbookingmenu.contractedbooking.origin'
      ),
      align: 'center',
      accessor: 'originCity',
    },
    {
      Header: t2(
        'manageordersscreen.createbookingmenu.contractedbooking.destination'
      ),
      align: 'center',
      accessor: 'destinationCity',
    },
    {
      Header: t2('manageordersscreen.createbookingmenu.contractedbooking.type'),
      align: 'center',
      accessor: 'region',
      Cell: (data) => {
        const { row } = data;
        return row?.original?.type && row?.original?.region
          ? `${row?.original?.type}, ${row?.original?.region}`
          : '--';
      },
    },
    {
      Header: t2(
        'manageordersscreen.createbookingmenu.contractedbooking.plant'
      ),
      align: 'center',
      accessor: 'plant',
      Cell: (data) => {
        const { row } = data;
        return row?.original?.plant || '--';
      },
    },
    {
      Header: t2(
        'manageordersscreen.createbookingmenu.contractedbooking.equipmenttype'
      ),
      align: 'center',
      accessor: 'equipment',
      Cell: (data) => {
        const { row } = data;
        return row?.original?.equipment || '--';
      },
    },
    {
      Header: t2(
        'manageordersscreen.createbookingmenu.contractedbooking.totalprice'
      ),
      align: 'center',
      accessor: 'totalUsd',
      Cell: (data) => {
        const { row } = data;
        const usaPartValue =
          row?.original?.usaPart || row?.original?.newUsPartyProposal || '--';

        return (
          <div className="d-flex justify-center align-center">
            {row?.original?.totalUsd
              ? `${row?.original?.totalUsd} ${
                  row?.original?.currency || ''
                }`.trim()
              : '--'}
            <CountIcon
              label={<GredientInfoIcon />}
              disableBorder
              disableHover
              columns={ContractBookingSmallTable()}
              data={[
                {
                  mexPart: row?.original?.mexPart || '--',
                  usaPart: usaPartValue,
                  crossing: row?.original?.crossing || '--',
                  miles: row?.original?.miles || '--',
                  fuel: row?.original?.fuel || '--',
                },
              ]}
              align="center"
              popoverPlacement="left"
              enableDynamicTable={true}
            />
          </div>
        );
      },
    },
  ];
};

const ConsolidatedMaterialsColumns = () => {
  const [t] = useTranslation('managecustoms');
  return [
    {
      Header: t('bookingFlow.consolidatedMaterials.orderid'),
      align: 'center',
      accessor: 'orderNo',
      Cell: (data) => {
        const { row } = data;
        return row?.original?.orderNo || '--';
      },
    },
    {
      Header: t('bookingFlow.consolidatedMaterials.materialid'),
      align: 'center',
      accessor: 'materialId',
      Cell: (data) => {
        const { row } = data;
        return row?.original?.materialId || '--';
      },
    },
    {
      Header: t('bookingFlow.consolidatedMaterials.materialgroup'),
      align: 'center',
      accessor: 'materialGroup',
      Cell: (data) => {
        const { row } = data;
        return row?.original?.materialGroup || '--';
      },
    },
    // {
    //   Header: t('bookingFlow.consolidatedMaterials.ccdate'),
    //   align: 'center',
    //   accessor: 'ccDate',
    //   Cell: (data) => {
    //     const { row } = data;
    //     return (
    //       <p>
    //         {row?.ccDate
    //           ? getUserTimeZoneDateFormat(row?.original?.ccDate)
    //           : '--'}
    //       </p>
    //     );
    //   },
    // },
    {
      Header: t('bookingFlow.consolidatedMaterials.qtyuom'),
      align: 'center',
      accessor: 'qtyUOM',
      Cell: (data) => {
        const { row } = data;
        return (
          <div className="d-flex justify-center">
            <NumberCard
              value={row?.original?.qtyUOM || 0}
              // content={t('manageordersscreen.order.tooltip.remaining')}
              size="small"
              status="remaining"
            />
            {row?.original?.uom || ''}
          </div>
        );
      },
    },
    {
      Header: t('bookingFlow.consolidatedMaterials.package'),
      align: 'center',
      accessor: 'package',
      Cell: (data) => {
        const { row } = data;
        const { original } = row;

        let textValue = '';

        if (original?.package) {
          const isVendor = original?.isVendorPackage === 'true';
          const [pkgName] = original.package.split(' X');
          const qtyText = isVendor ? 'NA' : original?.packageQty;
          textValue = `${pkgName} X ${qtyText}`;
        }

        return <p>{textValue}</p>;
      },
    },

    {
      Header: t('bookingFlow.consolidatedMaterials.pkgdimension'),
      align: 'center',
      accessor: 'pkgDimensions',
      Cell: (data) => {
        const { row } = data;
        const { original } = row;

        if (original?.isVendorPackage === 'true') {
          return <span className="no-wrap text-center d-block">NA</span>;
        }

        const rawValue = original.pkgDimensions;
        if (!rawValue) {
          return <span className="no-wrap text-center d-block">--</span>;
        }

        const [dimensionsPart, unitPart] = rawValue.split(' ');

        let unitLabel = '';
        if (unitPart === 'imperial') {
          unitLabel = 'In';
        } else if (unitPart === 'metric') {
          unitLabel = 'cm';
        }

        return (
          <span className="no-wrap text-center d-block">
            {dimensionsPart} {unitLabel}
          </span>
        );
      },
    },

    {
      Header: t('bookingFlow.consolidatedMaterials.weight'),
      align: 'center',
      accessor: 'weight',
      Cell: (data) => {
        const { row } = data;
        const { original } = row;

        if (original?.isVendorPackage === 'true') {
          return <p>NA</p>;
        }

        let textValue = '';
        if (original?.weight && isNumber(original?.unit)) {
          textValue = `${original.weight} ${original.unit}`;
        } else if (original?.weight) {
          textValue = original.weight;
        }

        const weightUnit = original?.pkgWtUnit === 'metric' ? 'Kgs' : 'Lbs';

        return <p>{`${textValue} ${weightUnit}`}</p>;
      },
    },
  ];
};

const CustomsEntriesColumns = () => {
  const [t] = useTranslation('managecustoms');
  return [
    {
      Header: t('bookingFlow.customEntries.customsRef'),
      align: 'center',
      accessor: (row) => {
        return row?.customsRef || '--';
      },
    },
    {
      Header: t('bookingFlow.customEntries.ral'),
      align: 'center',
      accessor: 'ral',
      Cell: (data) => {
        const {
          row: { original },
        } = data;
        return (
          <span className="d-inline-flex align-center button-border-hover">
            {original?.ral?.length > 0 && (
              <>
                <span className="link">{original?.ral}</span>
                <Action
                  label={`+${original.ral.length - 1}`}
                  className="icon-button ml-5 primary s-small justify-center"
                >
                  {original?.ral?.map((arr) => (
                    <button type="button">{arr}</button>
                  ))}
                </Action>
              </>
            )}
          </span>
        );
      },
    },
    {
      Header: t('bookingFlow.customEntries.associatedShipment'),
      align: 'center',
      accessor: (row) => {
        return row?.associatedShipment || '--';
      },
    },
    {
      Header: t('bookingFlow.customEntries.customsDeclaration'),
      align: 'center',
      accessor: (row) => {
        return row?.customsDeclaration || '--';
      },
    },
    {
      Header: t('bookingFlow.customEntries.customsStartDate'),
      align: 'center',
      accessor: 'customsStartDate',
      Cell: (data) => {
        const { row } = data;
        return row?.original?.customsStartDate
          ? getUserTimeZoneDateFormat(row.original.customsStartDate)
          : '--';
      },
    },
    {
      Header: t('bookingFlow.customEntries.customsCompDate'),
      align: 'center',
      accessor: 'customsCompDate',
      Cell: (data) => {
        const { row } = data;
        return row?.original?.customsCompDate
          ? getUserTimeZoneDateFormat(row.original.customsCompDate)
          : '--';
      },
    },
    {
      Header: t('bookingFlow.customEntries.status'),
      align: 'center',
      accessor: 'status',
      Cell: (data) => {
        const {
          row: { original },
        } = data;
        return <ListingStatus statusLabel={original?.status} />;
      },
    },
  ];
};
export const buyerBookingConsole = ({
  packageOptions,
  handleAddPackage,
  setNewValue,
  selectProduct,
  vendorPackageButton,
  originalQtys,
}) => [
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.consolidatebooking.orderid')}</>;
    },
    accessor: 'orderNo',
    align: 'center',
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.consolidatebooking.jdpo')}</>;
    },
    accessor: 'jdNo',
    align: 'center',
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.consolidatebooking.part')}</>;
    },
    accessor: 'partName',
    align: 'center',
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.sendbookingdetails.quantitytoship')}</>;
    },
    align: 'center',
    accessor: 'quantityToShip',
    Cell: (data) => {
      const { row } = data;
      const [t] = useTranslation('manageorders');

      /*     const {
        row: {
          index,
          // original: { errorMessage, ErrorColumn },
        },
      } = data; */
      const calculatedQtyToShip = originalQtys.find(
        (qty) => qty._id === row?.original?._id
      );

      return (
        <EditBox
          eanbleTextBox
          className="quantity-box"
          defaultValue={row?.original?.shippedQty}
          setNewValue={(e) => {
            setNewValue({
              values: e.target.value,
              columnName: 'quantityToShip',
              _id: row.original._id,
            });
          }}
          min="1"
          id="quantityToShip"
          name="quantityToShip"
          max={calculatedQtyToShip?.shippedQty}
          errorMessage={`${t(
            'manageordersscreen.sendbookingdetails.addpackagedetailsbtn.errormessage.quantity'
          )} ${calculatedQtyToShip?.shippedQty}`}
          errorLogic={calculatedQtyToShip?.shippedQty}
        />
      );
    },
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.consolidatebooking.dimensions')}</>;
    },
    accessor: 'dimensionsFormatted',
    align: 'center',
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.consolidatebooking.weight')}</>;
    },
    accessor: 'grossWeightAndUnitFormatted',
    align: 'center',
  },
  {
    Header: () => {
      const [t] = useTranslation('manageorders');
      return <>{t('manageordersscreen.sendbookingdetails.package')}</>;
    },
    accessor: 'package',
    align: 'center',
    setWidth: '170px',
    Cell: (data) => {
      const { row } = data;

      let defaultValue = row?.original?.package?.label;
      packageOptions?.forEach((obj) => {
        if (obj?.value === row?.original?.package?.value && obj?.rename) {
          if (obj?.rename?.length > 10) {
            defaultValue = `${obj?.rename?.slice(0, 11)}...`;
          } else {
            defaultValue = obj?.rename;
          }
        }
      });
      const [t] = useTranslation('manageorders');
      return (
        <div className="d-flex">
          <SearchSelect
            t={t}
            data={packageOptions}
            onClick={handleAddPackage}
            onChange={(e) => {
              setNewValue({
                values: {
                  label:
                    e.target.innerText ||
                    e.target.textContent ||
                    e.target.label,
                  value: e?.target?.value,
                },
                columnName: 'package',
                _id: row.original._id,
              });
            }}
            label={t('manageordersscreen.sendbookingdetails.packagetype.title')}
            defaultValue={defaultValue}
            selectProduct={selectProduct}
            disabled={vendorPackageButton}
          />
        </div>
      );
    },
  },
];

export {
  linerBooking,
  emailApprovalLiner,
  ContractBookingTable,
  ContractBookingSmallTable,
  ConsolidatedMaterialsColumns,
  CustomsEntriesColumns,
};
